// Import model
import { UpdateContactAssignmentRequest } from '../models/UpdateContactAssignmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateContactAssignmentRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateContactAssignmentRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateContactAssignmentRequest instance
   */
  static deserialize(json: string): UpdateContactAssignmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateContactAssignmentRequest instance
   */
  static fromObject(obj: any): UpdateContactAssignmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateContactAssignmentRequest');
    }


    const instance: UpdateContactAssignmentRequest = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      contactId: obj['contactId'] as string | undefined,
      role: obj['role'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateContactAssignmentRequest instances
   */
  static deserializeArray(json: string): UpdateContactAssignmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateContactAssignmentRequest instance to a JSON string
   */
  static serialize(instance: UpdateContactAssignmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateContactAssignmentRequest instance to a plain object
   */
  static toObject(instance: UpdateContactAssignmentRequest): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'contactId': instance.contactId,
      'role': instance.role,
    };
  }

  /**
   * Serializes an array of UpdateContactAssignmentRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateContactAssignmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
